import common from './common';
import message from './message';
import alimtalk from './alimtalk';
import kakaoBasic from './kakaoBasic';
import kakaoWideItemList from './kakaoWideItemList';
import kakaoCommerce from './kakaoCommerce';
import kakaoCarouselFeed from './kakaoCarouselFeed';
import kakaoCarouselCommerce from './kakaoCarouselCommerce';
import kakaoPremiumVideo from './kakaoPremiumVideo';

export default {
  ...common,
  message,
  alimtalk,
  kakaoBasic,
  kakaoWideItemList,
  kakaoCommerce,
  kakaoCarouselFeed,
  kakaoCarouselCommerce,
  kakaoPremiumVideo,
};
